<svg width="11" height="12" viewBox="0 0 11 12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M10.655 1.545 9.38.33A1.208 1.208 0 0 0 8.548 0H4.32c-.65 0-1.178.504-1.178 1.125V2.25H1.179C.528 2.25 0 2.754 0 3.375v7.5C0 11.496.528 12 1.179 12h5.5c.65 0 1.178-.504 1.178-1.125V9.75h1.964c.651 0 1.179-.504 1.179-1.125V2.341a1.1 1.1 0 0 0-.345-.796zm-4.124 9.33H1.326a.144.144 0 0 1-.147-.14v-7.22c0-.077.066-.14.147-.14h1.817v5.25c0 .621.528 1.125 1.178 1.125H6.68v.984c0 .078-.066.141-.148.141zm3.143-2.25H4.47a.144.144 0 0 1-.148-.14v-7.22c0-.077.066-.14.148-.14H7.07v2.063c0 .31.264.562.59.562h2.16v4.734c0 .078-.066.141-.147.141zm.147-6H8.25v-1.5h.236c.04 0 .077.015.105.041L9.778 2.3a.137.137 0 0 1 .043.1v.225z" id="u5lob0djna"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="pxsjj9bibb" fill="#fff">
            <use xlink:href="#u5lob0djna"/>
        </mask>
        <use fill="#8CA0C3" fill-rule="nonzero" xlink:href="#u5lob0djna"/>
        <g mask="url(#pxsjj9bibb)" fill="currentColor">
            <path d="M-12.27-5.525h32.155v22.4H-12.27z"/>
        </g>
    </g>
</svg>
